<template>
  <FiltersWrapper>
    <CollapseBlock class="filters" tablet-mode>
      <div class="filters__item filters__item--resident">
        <CustomSelect
          fullWidth
          :options="this.residents"
          label="ЖК"
          optionValueKey="resident_id"
          optionLabelKey="resident_name"
          :value="this.filters.resident_id"
          @change="(value, row) => onFiltersChange('resident_id', value, row)"
        />
      </div>
      <div class="filters__item filters__item--project-type">
        <CustomSelect
          fullWidth
          :options="this.projectTypes"
          label="Тип проекта"
          optionValueKey="project_type_id"
          optionLabelKey="project_type_name"
          :value="this.filters.project_type_id"
          @change="(value, row) => onFiltersChange('project_type_id', value, row)"
        />
      </div>
      <div class="filters__item filters__item--entrance">
        <CustomSelect
          fullWidth
          :options="this.entrances"
          label="Подъезд"
          optionValueKey="project_entrance_id"
          optionLabelKey="entrance_name"
          :loading="this.entrancesFetching"
          :value="this.filters.project_entrance_id"
          @change="(value, row) => onFiltersChange('project_entrance_id', value, row)"
        />
      </div>
    </CollapseBlock>
  </FiltersWrapper>
</template>

<script>
import CollapseBlock from "@/components/common/CollapseBlock";
import FiltersWrapper from "@/components/common/FiltersWrapper";
import CustomSelect from "@/components/form/CustomSelect";
import { getProjectTypes, getResidentialEntrances, getResidentList } from "./services";

export default {
  name: "ProjectSettingsFilters",
  components: { CustomSelect, CollapseBlock, FiltersWrapper },
  props: ['filters', 'onChange', 'needsUpdate', 'onUpdateSelectedData'],
  data() {
    return {
      residents: [],
      entrances: [],
      projectTypes: [],
      entrancesFetching: false,
    }
  },
  async mounted() {
    const { resident_id, project_type_id } = this.filters
    const tasks = [this.getResidents()]
    if (resident_id) tasks.push(this.getProjectTypesData(resident_id))
    if (project_type_id) tasks.push(this.getEntrances(this.filters))
    await Promise.all(tasks)
  },
  methods: {
    async getResidents() {
      const res = await getResidentList()
      this.residents = res || []

      if (this.needsUpdate && this.residents.length && this.filters.resident_id) {
        const resident = this.residents.find(r => r.resident_id === this.filters.resident_id)
        if (resident) {
          this.onUpdateSelectedData(resident)
        }
      }
    },
    async getProjectTypesData(resident_id) {
      const res = await getProjectTypes(resident_id)
      this.projectTypes = res || []
      if (this.needsUpdate && this.projectTypes.length && this.filters.project_type_id) {
        const projectType = this.projectTypes.find(r => r.project_type_id === this.filters.project_type_id)
        this.onUpdateSelectedData(projectType)
      }
    },
    async getEntrances(filters) {
      this.entrancesFetching = true
      const res = await getResidentialEntrances(filters)
      this.entrancesFetching = false
      this.entrances = res || []

      if (this.needsUpdate && this.entrances.length && this.filters.project_entrance_id) {
        const entrance = this.entrances.find(r => r.project_entrance_id === this.filters.project_entrance_id)
        if (entrance) {
          this.onUpdateSelectedData(entrance)
        }
      }

      // При выборе ЖК и типа проекта (без подъезда) всегда показываем вкладку Материалы
      // Если подъезд не выбран, показываем только Материалы
      if (!filters?.project_entrance_id && filters?.resident_id != null && filters?.project_type_id != null) {
        const sbs_project_id = filters?.sbs_project_id ?? this.residents.find(r => r.resident_id === filters?.resident_id)?.sbs_project_id;
        this.$emit('preorderCodeChecked', {
          showMaterialTab: true,
          params: {
            project_type_id: filters.project_type_id,
            resident_id: filters.resident_id,
            sbs_project_id: sbs_project_id ?? undefined,
          }
        });
      }
    },
    onFiltersChange(key, value, row) {
      if (key === 'resident_id') {
        if (!!value)
          this.getProjectTypesData(value)
        else {
          this.projectTypes = []
          this.entrances = []
        }
      }
      if (key === 'project_type_id') {
        if (this.filters.resident_id) {
          value && this.getEntrances({ ...this.filters, [key]: value })
        }
        if (!value) {
          this.entrances = []
        }
      }
      this.onChange(key, value, row)
    },
  }
}
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 20px;

  &__item {
    min-width: 150px;

    &--resident {
      flex: 1 1 300px;
      min-width: 300px;
      max-width: 480px;
    }

    &--project-type {
      flex: 2 1 400px;
      min-width: 400px;
      max-width: 640px;
    }

    &--entrance {
      flex: 1 1 300px;
      min-width: 300px;
      max-width: 480px;
    }

    :deep(.custom-select__wrapper) {
      width: 100%;
    }
  }
}
</style>
